import React from 'react';

import PropTypes from 'prop-types';
import FaCertificate from 'react-icons/lib/fa/certificate';

import BaseHeroHeader from 'wanderu-component-hero-header';

import localize from 'wanderu-i18n/src/localize';

import cgConfig from '../../../../config/carrierguide.locale';

import styles from './CarrierGuideHeader.scss';

function OfficialPartnerBadge(props) {
    const {
        t,
    } = props;

    return (
        <div className={styles.partnerIndicator}>
            <FaCertificate className={styles.partnerIcon} />
            {t('officialPartner')}
        </div>
    );
}

const LocalizedOfficialPartnerBadge = localize(OfficialPartnerBadge, ['t'], cgConfig.namespace);

function CarrierGuideHeader(props) {
    const {
        t,
        id,
        travelMode,
        carrierActiveStatus,
    } = props;
    const title = t('widgetTitle');
    const queries = { dc: `${id}:${travelMode}`, dm: `${travelMode}` };

    const showBadge = !!id && carrierActiveStatus === 'active';

    return (
        <BaseHeroHeader
            title={title}
            widgetProps={{ queries }}
        >
            {showBadge && <LocalizedOfficialPartnerBadge />}
        </BaseHeroHeader>
    );
}

CarrierGuideHeader.propTypes = {
    carrierActiveStatus: PropTypes.string.isRequired,
    id: PropTypes.string,
    travelMode: PropTypes.string,
};

CarrierGuideHeader.defaultProps = {
    id: '',
    travelMode: '',
};

export {
    CarrierGuideHeader,
    LocalizedOfficialPartnerBadge as OfficialPartnerBadge,
};
export default localize(CarrierGuideHeader, ['t'], cgConfig.namespace);
